import { render, staticRenderFns } from "./AboutJoinedSchool.vue?vue&type=template&id=e42a9ab4&scoped=true&"
import script from "./AboutJoinedSchool.vue?vue&type=script&lang=js&"
export * from "./AboutJoinedSchool.vue?vue&type=script&lang=js&"
import style0 from "./AboutJoinedSchool.vue?vue&type=style&index=0&id=e42a9ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42a9ab4",
  null
  
)

export default component.exports